import { Alert, CircularProgress, Stack, Typography } from '@mui/material'
import type { Answer } from '../api/generated/Answer'
import type { Question } from '../api/generated/Question'
import { useApi } from '../api/useApi'
import { displayAnswer, formOf } from './form'

/** A volunteer's answers to the event's questions, for organizers. */
export function AnswerList({ slug, userId }: { slug: string; userId: string }) {
  const questions = useApi<Question[]>(`/events/${slug}/questions`)
  const answers = useApi<Answer[]>(`/events/${slug}/answers`)
  const error = questions.error ?? answers.error
  const form = answers.data && formOf(answers.data, userId)
  if (error) return <Alert severity="error">{error}</Alert>
  if (!(questions.data && form)) return <CircularProgress />
  if (questions.data.length === 0)
    return <Typography color="text.secondary">Aucune question posée aux bénévoles.</Typography>
  return (
    <Stack spacing={2}>
      {questions.data.map((question) => (
        <div key={question.id}>
          <Typography variant="body2" color="text.secondary">
            {question.label}
          </Typography>
          <Typography sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
            {displayAnswer(question, form[question.id])}
          </Typography>
        </div>
      ))}
    </Stack>
  )
}
